/* eslint-disable */
import type {DocumentNode} from 'graphql';
import * as ApolloReactHooks from '@apollo/client/react';
import type {OauthUrlQuery, OauthUrlQueryVariables} from '../types';

export const OauthUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OauthUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"provider"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"oauthUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"provider"},"value":{"kind":"Variable","name":{"kind":"Name","value":"provider"}}}]}]}}]} as unknown as DocumentNode;
/** hook для запроса "OauthUrl" */
export function useOauthUrlQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<OauthUrlQuery, OauthUrlQueryVariables>,
) {
    return ApolloReactHooks.useQuery<OauthUrlQuery, OauthUrlQueryVariables>(
        OauthUrlDocument,
        baseOptions ?? ({} as ApolloReactHooks.QueryHookOptions<OauthUrlQuery, OauthUrlQueryVariables>),
    );
}
